import React from 'react';
import { MarketingArticle } from './marketingArticle.jsx';
import heroImage from '../pictures/003.avif';
import cityImage from '../pictures/Singapore City 3.webp';
import patentImage from '../pictures/Patent EU.avif';

export function BSB700() {
  return (
    <MarketingArticle
      title="BSB 700"
      kicker="High-end roadmap"
      description="A future Back-Step Blockchain platform for large deployments, high-value services, and demanding trust infrastructure."
      path="/products"
      heroImage={heroImage}
      heroAlt="BSB 700 hardware concept"
      primaryAction={{ to: '/contact', label: 'Discuss roadmap' }}
      secondaryAction={{ to: '/investors', label: 'Investor information' }}
      sections={[
        {
          tag: 'Ambition',
          title: 'Built for organizations that want to own the trust layer.',
          image: cityImage,
          imageAlt: 'Singapore city skyline',
          paragraphs: [
            'BSB 700 is positioned for larger deployments where Back-Step Blockchain becomes part of the organization’s critical digital infrastructure.',
            'Potential applications include national systems, high-value supply chains, large commercial platforms, and partner-operated trust services.',
          ],
        },
        {
          tag: 'Protection',
          title: 'Patented technology gives the roadmap a defensible base.',
          image: patentImage,
          imageAlt: 'European patent certificate',
          paragraphs: [
            'Back-Step Blockchain is protected by patents in multiple jurisdictions. The roadmap combines that intellectual property with hardware, software, and partner applications.',
            'We discuss technical detail, availability, and licensing structure directly with strategic partners.',
          ],
        },
      ]}
    />
  );
}
